import React from 'react'
import { removeWhitespaceAndSpecialChars } from '../../helpers/commons'
import { Icon } from '../../../atoms'

interface Item {
  name: string
  url: string
}

export interface StickyNavProps {
  jsonBody: {
    sections: Item[]
  }
  variant: string
  rawName: string
  sys: { id: string }
}

const StickyNav = ({ jsonBody, variant, rawName, sys }: StickyNavProps) => {
  try {
    return (
      <div data-controller='sticky-nav'>
        <span className='title' id='navigationTitle' data-sticky-nav-target='stickyNavTitle'>
          On this page
        </span>
        <div className='navigation-wrapper' data-sticky-nav-target='stickyNavWrapper'>
          <div className='navigation' id='stickyNavHeader' data-sticky-nav-target='stickyNavHeader'>
            <div
              className='navigation__icon disabledIcon'
              data-sticky-nav-target='leftIconButton'
              id='navigation__icon__left' /* eslint-disable camelcase */
              data-action='click->sticky-nav#leftArrowIconClick'
              data-click-tracking={JSON.stringify({
                component_category: 'platinum-component',
                component_id: sys?.id,
                component_name: 'stickyNav',
                contentful_name: rawName,
                contentful_variant: variant,
                additionalProps: { button: 'arrow-left' },
              })}
            >
              <Icon glyph={'ButtonLeftDisabled'} size={26} desktopSize={42} color='#adafb3' />
            </div>
            <div className='navigation__sub-container'>
              <div
                className='navigation__sub-container__animate'
                data-sticky-nav-target='subContainerContent'
              >
                {jsonBody.sections.map((ele, index) => (
                  <a
                    key={index}
                    href={`#${removeWhitespaceAndSpecialChars(ele.url)}`}
                    data-ele={`data-${removeWhitespaceAndSpecialChars(ele.url)}`}
                    data-click-tracking={JSON.stringify({
                      component_category: 'platinum-component',
                      component_id: sys?.id,
                      component_name: 'stickyNav',
                      contentful_name: rawName,
                      contentful_variant: variant,
                      additionalProps: { text: ele.url },
                    })}
                  >
                    <span>{ele.name}</span>
                  </a>
                ))}
              </div>
            </div>
            <div
              className='navigation__icon'
              data-sticky-nav-target='rightIconButton'
              id='navigation__icon__right'
              data-action='click->sticky-nav#rightArrowIconClick'
              data-click-tracking={JSON.stringify({
                component_category: 'platinum-component',
                component_id: sys?.id,
                component_name: 'stickyNav',
                contentful_name: rawName,
                contentful_variant: variant,
                additionalProps: { button: 'arrow-right' },
              })}
            >
              <Icon glyph={'arrow-right'} size={26} desktopSize={42} color='#adafb3' />
            </div>
          </div>
        </div>
      </div>
    )
  } catch (error) {
    return <></>
  }
}

export default StickyNav
